import type { TravelerFields } from '../../../api/reservationInfo';

export type TravelerFieldRules = {
  isRequired: (fieldName: string) => boolean;
  isVisible: (fieldName: string) => boolean;
};

export const createTravelerFieldRules = (travelerFields: TravelerFields): TravelerFieldRules => ({
  isRequired: (fieldName: string) => travelerFields.required.includes(fieldName),
  isVisible: (fieldName: string) =>
    travelerFields.required.includes(fieldName) || travelerFields.optional.includes(fieldName)
});
